import { create } from "zustand";
import { axiosHelper, tokenHelper } from "./helpers";

export const useAppConfigStore = create((set) => ({
  config: null,
  isLoading: false,
  savingType: null,
  isError: false,
  error: undefined,

  getVersionConfig: async () => {
    try {
      set({ isLoading: true, isError: false, error: undefined });
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.get("/v2/app-config/version", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const config = response?.data || response;
      set({
        config,
        isLoading: false,
        isError: false,
      });
      return config;
    } catch (error) {
      console.error("Error fetching app version config:", error);
      set({
        config: null,
        isLoading: false,
        isError: true,
        error: error.message,
      });
      return null;
    }
  },

  updateVersionConfig: async (body) => {
    const savingType = body.userapp ? "userapp" : "serviceapp";
    try {
      set({ savingType, isError: false, error: undefined });
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.put("/v2/app-config/version", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const config = response?.data || response;
      set({
        config,
        savingType: null,
        isError: false,
      });
      return config;
    } catch (error) {
      console.error("Error updating app version config:", error);
      set({
        savingType: null,
        isError: true,
        error: error.message,
      });
      throw error;
    }
  },
}));
